import React, { useEffect, useState } from "react";
import axios from "axios";

const BlockedUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("token");

  // ✅ Fetch Locked Users
  const fetchLockedUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://api.getfitindia.in/api/auth/locked-users",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUsers(res.data || []);
    } catch (err) {
      console.error("Error fetching locked users:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Unlock User
  const handleUnlock = async (userId) => {
    try {
      const res = await axios.put(
        `https://api.getfitindia.in/api/auth/unlock-user/${userId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage(res.data.message || "User unlocked successfully");
      fetchLockedUsers(); // refresh list
    } catch (err) {
      console.error("Error unlocking user:", err);
      setMessage("Failed to unlock user");
    }
  };

  useEffect(() => {
    fetchLockedUsers();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F7FB]">
      {/* Top dark bar */}
    
 {/* HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl  px-4 py-4">
       <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
   Blocked / Locked Users
</h1>

        </div>
      </div>

      <div className="flex-1 px-3 sm:px-5 lg:px-10 py-4 overflow-y-auto">
        {/* Status message */}
        {message && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-sm shadow-sm">
            {message}
          </div>
        )}

        {/* Main card */}
        <div className="bg-white rounded-2xl shadow-[0_0_6px_rgba(0,0,0,0.2)] border border-[#E6EBF2] overflow-hidden">
          {/* Card header strip */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-6 py-4 bg-[#F5F8FF] border-b border-[#E6EBF2]">
            <div>
              <p className="text-sm text-gray-500">Users List</p>
              <h2 className="text-base sm:text-lg font-semibold text-[#0C295F]">
                All Blocked / Locked Users
              </h2>
            </div>
            <div className="text-xs sm:text-sm text-gray-600">
              Total:{" "}
              <span className="font-semibold text-[#0C295F]">
                {users.length}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="overflow-x-auto">
            {loading ? (
              <div className="px-6 py-6 text-sm text-gray-500">
                Loading blocked users...
              </div>
            ) : users.length === 0 ? (
              <div className="px-6 py-6 text-sm text-green-600">
                No blocked users 🎉
              </div>
            ) : (
              <table className="w-full text-sm">
                <thead className="bg-[#E5EDFF] text-[#0C295F]">
                  <tr>
                    <th className="px-6 py-3 text-left font-semibold">#</th>
                    <th className="px-6 py-3 text-left font-semibold">Name</th>
                    <th className="px-6 py-3 text-left font-semibold">
                      Mobile
                    </th>
                    <th className="px-6 py-3 text-left font-semibold">
                      Locked Until
                    </th>
                    <th className="px-6 py-3 text-left font-semibold">
                      Last Reason
                    </th>
                    <th className="px-6 py-3 text-left font-semibold">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, idx) => {
                    const lastHistory =
                      user.lockHistory && user.lockHistory.length > 0
                        ? user.lockHistory[user.lockHistory.length - 1].reason
                        : "N/A";

                    return (
                      <tr
                        key={user._id}
                        className={
                          idx % 2 === 0 ? "bg-white" : "bg-[#F8FAFF]"
                        }
                      >
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          {idx + 1}
                        </td>
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          {user.name || "N/A"}
                        </td>
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          {user.mobile}
                        </td>
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          {user.lockUntil
                            ? new Date(
                                user.lockUntil
                              ).toLocaleString()
                            : "N/A"}
                        </td>
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          {lastHistory}
                        </td>
                        <td className="px-6 py-3 border-t border-[#E6EBF2]">
                          <button
                            onClick={() => handleUnlock(user._id)}
                            className="px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-[#10B981] hover:bg-[#059669] text-white shadow-sm"
                          >
                            Unlock
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockedUsers;
